import { useEffect } from 'react';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useToast } from '@/ui';

const RESULT_PARAM = 'code';
const ERROR_RESULT = 'ERROR';
const REJECT_RESULT = 'ACCESS_DENIED';

export const useHandleConnectFailed = () => {
  const toast = useToast();
  const { queryParams, removeQueryParam } = useQueryParams();
  const code = queryParams.get(RESULT_PARAM);

  useEffect(() => {
    if (code) {
      if (code === ERROR_RESULT) {
        toast.error(
          'Whoops! Something went wrong while connecting to Canva. Please try again'
        );
      }
      if (code === REJECT_RESULT) {
        toast.info('Canva connection canceled.');
      }

      removeQueryParam(RESULT_PARAM);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
